import React, { useState, useEffect, useMemo, useCallback, useContext, memo } from "react";
import { FaSearch, FaLink } from "react-icons/fa";
import "./CodeBook.css";
import bookOpenIcon from "../../assets/bookopen.png";
import booksIcon from "../../assets/books.png";
import bookInactiveIcon from "../../assets/booksinactive.png";
import achiIcon from "../../assets/achiinedx.png";
import indexIcon from "../../assets/Index.png";
import tabularicdIcon from "../../assets/icdtabular.png";
import australianIcon from "../../assets/austrilaincode.png";
import bookIcon from "../../assets/book.png";
import icd10amIcon from "../../assets/icd10am.png";
import starsIcon from "../../assets/starts.png";
import pako from "pako";
import { CodeContext } from "../pages/Coder/Coder";
import { useDebounce } from 'use-debounce';
import { toast } from "react-toastify";
import { useSelector,useDispatch } from "react-redux"; // Import useSelector
import { Spinner } from "react-bootstrap";
import Bookopen from "../../common/assets/images/book-open-02 (1).png";
import LdsRoller from "../../utils/LdsRoller";
import { green } from "@mui/material/colors";
// import AustralianCodebook from "./AustralianCodebook";
import USACodebook from "./USACodebook";
// import { ToggleSlider } from 'react-toggle-slider';
import ToggleButton from "./ToggleSlider";
import { fetchCodebookData} from "./redux/CodeBookSlicer";


const CodeBookUsa = React.memo(({ activeIcon,setActiveIcon,activeTab,setActiveTab}) => {
const dispatch = useDispatch();

  // const [activeIcon, setActiveIcon] = useState("ICD");
  // const [activeTab, setActiveTab] = useState("ICD 10 CM Index");
  const [searchQuery, setSearchQuery] = useState("");
  const [droppedCodes, setDroppedCodes] = useState([]);
  const [rawSearchQuery, setRawSearchQuery] = useState("");
  const [debouncedQuery] = useDebounce(rawSearchQuery, 300); // Debounce here
  const { selectedCodeBookCode, selectedTabKeyCoding } = useContext(CodeContext);
  const [usePCSVersion, setUsePCSVersion] = useState(false);
  // console.log( selectedTabKeyCoding," selectedTabKeyCoding")
  const {
    icd10amTabularData,
    icd10amIndexData,
    achiIndexData,
    achiTabularData,
    pcsIndexData,
    pcsTabularData,
    isFetched12,
    codeBookLoading,
    codeBookError,
  } = useSelector((state) => state.codeBook);
useEffect(() => {
  if (!isFetched12) {
    dispatch(fetchCodebookData());
  }
}, [isFetched12, dispatch]); 
  const tabsConfig = useMemo(() => {
    return [
      { name: "ICD 10 CM Index", data: icd10amIndexData || [] },
      { name: "ICD 10 CM Tabular", data: icd10amTabularData || [] },
      { name: "PCS Index", data: pcsIndexData || [] },
      { name: "PCS Tabular", data: pcsTabularData || [] },
      { name: "CPT Tabular", data: achiTabularData || [] },
      { name: "CPT Index", data: achiIndexData || [] },
      { name: "American Coding Standard", data: [] },
    ];
  }, [icd10amIndexData, icd10amTabularData, achiTabularData, achiIndexData, pcsIndexData, pcsTabularData]);

  const getTabError = () => {
    if (!codeBookError) return null;
    switch (activeTab) {
      case "ICD 10 CM Tabular":
        return codeBookError.icd10amTabular ? `Failed to load ICD 10 CM Tabular data: ${codeBookError.icd10amTabular}` : null;
      case "ICD 10 CM Index":
        return codeBookError.icd10amIndex ? `Failed to load ICD 10 CM Index data: ${codeBookError.icd10amIndex}` : null;
      case "CPT Tabular":
        return codeBookError.achiTabular ? `Failed to load CPT Tabular data: ${codeBookError.achiTabular}` : null;
      case "CPT Index":
        return codeBookError.achiIndex ? `Failed to load CPT Index data: ${codeBookError.achiIndex}` : null;
      default:
        return null;
    }
  };

  const tabError = getTabError();

  useEffect(() => {

    const savedActiveTab = localStorage.getItem("activeTab");
    const savedActiveIcon = localStorage.getItem("activeIcon");

    if (savedActiveTab) {
      setActiveTab(savedActiveTab); // Set active tab if saved in localStorage
    }

    if (savedActiveIcon) {
      setActiveIcon(savedActiveIcon); // Set active icon if saved in localStorage
    }
  }, []);


  useEffect(() => {
    localStorage.setItem("activeTab", activeTab); // Save active tab to localStorage
    localStorage.setItem("activeIcon", activeIcon); // Save active icon to localStorage

  }, [activeTab, activeIcon]);


  useEffect(() => {
    if (selectedCodeBookCode && selectedTabKeyCoding) { // Check both are available
      setRawSearchQuery(selectedCodeBookCode);

      // if (selectedTabKeyCoding === "CPT" || selectedTabKeyCoding === "ACHI") {
      //   setActiveIcon("Tabular"); // Or your preferred ACHI icon
      //   // setActiveTab("CPT Tabular"); // Correct tab for ACHI
      //   setActiveTab(usePCSVersion ? "CPT Tabular" : "PCS Tabular");

      // }
      if (selectedTabKeyCoding === "PCS") {
        setUsePCSVersion(false);
        setActiveIcon("Tabular");
        setActiveTab("PCS Tabular");

      } else if (selectedTabKeyCoding === "CPT" || selectedTabKeyCoding === "ACHI") {
        setUsePCSVersion(true);
        setActiveIcon("Tabular");
        setActiveTab("CPT Tabular");

      }
      else { // Either ICD or default (ICD)
        setActiveIcon("Tabular");
        setActiveTab("ICD 10 CM Tabular"); // Correct tab for ICD (and default)
      }
    } else {
      setRawSearchQuery("");
      setActiveIcon("ICD");
      setActiveTab("ICD 10 CM Index");
    }
  }, [selectedCodeBookCode, selectedTabKeyCoding]);

  useEffect(() => {

    if (debouncedQuery.length >= 3) {
      setSearchQuery(debouncedQuery);
    } else {
      setSearchQuery(""); // Clear if less than 3 chars
    }
  }, [debouncedQuery]); // debouncedQuery is the dependency


  const filterData = (items, query) => {
    // if (!query) return items; // Return original items if query is empty
    if (!query || query.length < 3) return items; // Return empty array


    const lowerCaseQuery = typeof query === 'string' ? query.toLowerCase() : ""; // Handle anything

    const results = [];
    const filterRecursive = (items) => { // Inner recursive function
      return items.map((item) => {
        const filteredChildren = item.children ? filterRecursive(item.children) : [];
        const matchesParent = (item.name && item.name.toLowerCase().includes(lowerCaseQuery)) ||
          (item.description && item.description.toLowerCase().includes(lowerCaseQuery));

        // const matches = matchesParent || filteredChildren.length > 0;

        const childrenToInclude = matchesParent ? item.children || [] : filteredChildren;

        return {
          ...item,
          // children: filteredChildren,
          // matches,
          children: childrenToInclude, // Preserve all children if parent matches
          matches: matchesParent || childrenToInclude.length > 0,
        };
      }).filter((item) => item.matches || item.children?.length > 0);
    };

    return filterRecursive(items);
  };


  const filteredDataMemo = useMemo(() => {
    const currentTabData = tabsConfig.find(tab => tab.name === activeTab)?.data
    return filterData(currentTabData || [], searchQuery);
  }, [activeTab, searchQuery, tabsConfig]); // activeTab is a dependencys

  const handleSearchChange = (e) => {
    const newValue = e.target.value;
    if (newValue !== rawSearchQuery) {
      setRawSearchQuery(newValue);
    }
    // setRawSearchQuery(e.target.value); // Update raw input
  };


  const handleIconClick = (icon) => {
    setActiveIcon(icon);
    if (icon === "ICD") setActiveTab("ICD 10 CM Index");
    else if (icon === "Tabular") setActiveTab("ICD 10 CM Tabular");
    else if (icon === "Coding") setActiveTab("American Coding Standard");

  };

  const getIcon = (icon) => {
    if (icon === "ICD") {
      return activeTab === "ICD 10 CM Index"
        ? booksIcon
        : (activeTab === "CPT Index" || activeTab === "PCS Index")
          ? achiIcon
          : bookInactiveIcon; // Inactive icon for ICD
    }

    if (icon === "Tabular") {
      return activeTab === "ICD 10 CM Tabular"
        ? tabularicdIcon
        : (activeTab === "CPT Tabular" || activeTab === "PCS Tabular")
          ? icd10amIcon
          : bookInactiveIcon; // Inactive icon for Tabular
    }

    if (icon === "Coding") {
      return activeTab === "American Coding Standard"
        ? australianIcon : bookIcon;
    }

    return bookInactiveIcon;
  };


  const handleDrop = (code) => {
    setDroppedCodes((prev) => [...prev, code]);
  };


  const [displayedItems, setDisplayedItems] = useState([]); // Items to render
  const [loadMore, setLoadMore] = useState(50); // Number of items to load
  const searchResultsRef = React.useRef(null);

  useEffect(() => {
    setDisplayedItems(filteredDataMemo.slice(0, loadMore));
  }, [filteredDataMemo, loadMore]);

  const handleScroll = useCallback(() => {
    if (!searchResultsRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = searchResultsRef.current;

    // If scrolled to the bottom, load 10 more items
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      setLoadMore((prev) => prev + 10);
    }
  }, []);


  useEffect(() => {
    const element = searchResultsRef.current;
    if (element) {
      element.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (element) {
        element.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);
  const handleVersionToggle = (checked) => {
    setUsePCSVersion(checked);

    // if (activeIcon === "ICD") {
    //       setActiveTab(checked ? "PCS Index" : "CPT Index")
    // } else if (activeIcon === "Tabular") {
    //   setActiveTab(checked ? "PCS Tabular" : "CPT Tabular");
    // }
    if (activeIcon === "ICD") {
      if (activeTab === "CPT Index" || activeTab === "PCS Index") {
        setActiveTab(checked ? "PCS Index" : "CPT Index");
      }
      // Else keep "ICD 10 CM Index" or other ICD tabs untouched
    } else if (activeIcon === "Tabular") {
      if (activeTab === "CPT Tabular" || activeTab === "PCS Tabular") {
        setActiveTab(checked ? "PCS Tabular" : "CPT Tabular");
      }
      // Else keep ICD Tabular untouched
    }
  };
  const expectedTabularTab = usePCSVersion ? "CPT Tabular" : "PCS Tabular";
  const expectedIndexTab = usePCSVersion ? "CPT Index" : "PCS Index";

  return (
    <div className="codebook-container">

      <div className="codebook1-header">
        <span
          className={`header-navicon ${activeIcon === "ICD" ? "active-icon" : ""}`}
          onClick={() => handleIconClick("ICD")}
        >
          <img src={getIcon("ICD")} alt="ICD Icon" width={30} height={30} />
        </span>
        <span
          className={`header-navicon ${activeIcon === "Tabular" ? "active-icon" : ""}`}
          onClick={() => handleIconClick("Tabular")}
        >
          <img src={getIcon("Tabular")} alt="Tabular Icon" width={30} height={30} />
        </span>
        <span
          className={`header-navicon ${activeIcon === "Coding" ? "active-icon" : ""}`}
          onClick={() => handleIconClick("Coding")}
        >
          <img src={getIcon("Coding")} alt="Coding Icon" width={30} height={30} />
        </span>
        <span style={{ marginLeft: 'auto' }}>
          <ToggleButton
            className="codebook-version-select"
            onChange={handleVersionToggle}
            checked={usePCSVersion}
          />
        </span>
      </div>

      <div className="tabs-codes">
        {activeIcon === "ICD" && (
          <>
            <button
              className={activeTab === "ICD 10 CM Index" ? "active" : ""}
              style={{ borderBottomColor: activeTab === "ICD 10 CM Index" ? "#FFE404" : "transparent" }}
              onClick={() => setActiveTab("ICD 10 CM Index")}
            >
              ICD 10 CM Index
            </button>
            {/* <button
              className={activeTab === (usePCSVersion ? "CPT Index" : "PCS Index") ? "active" : ""}
              style={{
                borderBottomColor: activeTab === (usePCSVersion ? "CPT Index" : "PCS Index") ? "green" : "transparent",
              }}
              onClick={() => setActiveTab(usePCSVersion ? "CPT Index" : "PCS Index")}
            >
              {usePCSVersion ? "CPT Index" : "PCS Index"}
            </button> */}

            <button
              className={activeTab === expectedIndexTab ? "active" : ""}
              style={{ borderBottomColor: activeTab === expectedIndexTab ? "green" : "transparent" }}
              onClick={() => setActiveTab(expectedIndexTab)}
            >
              {expectedIndexTab}
            </button>
          </>
        )}
        {activeIcon === "Tabular" && (
          <>
            <button
              className={activeTab === "ICD 10 CM Tabular" ? "active" : ""}
              style={{ borderBottomColor: activeTab === "ICD 10 CM Tabular" ? "red" : "transparent" }}
              onClick={() => setActiveTab("ICD 10 CM Tabular")}
            >
              ICD 10 CM Tabular
            </button>
            {/* <button
              className={activeTab === (usePCSVersion ? "CPT Tabular" : "PCS Tabular") ? "active" : ""}
              style={{
                borderBottomColor: activeTab === (usePCSVersion ? "CPT Tabular" : "PCS Tabular") ? "blue" : "transparent",
              }}
              onClick={() => setActiveTab(usePCSVersion ? "CPT Tabular" : "PCS Tabular")}
            >
              {usePCSVersion ? "CPT Tabular" : "PCS Tabular"}
            </button> */}
            <button
              className={activeTab === expectedTabularTab ? "active" : ""}
              style={{ borderBottomColor: activeTab === expectedTabularTab ? "blue" : "transparent" }}
              onClick={() => setActiveTab(expectedTabularTab)}
            >
              {expectedTabularTab}
            </button>


          </>
        )}
        {activeIcon === "Coding" && (
          <button className={activeTab === "American Coding Standard" ? "active" : ""} style={{ borderBottomColor: "purple" }}>
            American Coding Standards(ACS)
          </button>
        )}
      </div>

      {/* <div className="search-bar-code">
        <FaSearch className="search-icon" />
        <input
          type="text"
          className="search-input"
          placeholder="Search by code or description"
          value={rawSearchQuery}
          onChange={handleSearchChange}
        />
 
      </div> */}
      {activeTab !== "American Coding Standard" &&
        <div className="search-bar-code">
          <FaSearch className="codebook-search-icon" />
          <input
            type="text"
            className="search-input"
            placeholder="Search by code or description"
            value={rawSearchQuery}
            onChange={handleSearchChange}
          />

        </div>
      }


      <div className="search-results" ref={searchResultsRef}>
        {activeTab === "American Coding Standard" &&
          <USACodebook />
        }

        <div className="accordion-container">
          {/* {
            codeBookLoading ? <div className="codebook-loader">
              <Spinner />{" "}
            </div> : <>
              {displayedItems.map((item,index) => (<AccordionItem key={index} item={item} searchQuery={searchQuery} activeTab={activeTab} />))}
            </>
          } */}
          {codeBookLoading ? (
            <div className="codebook-loader">
              <LdsRoller />
            </div>
          ) : (
            <>
              {displayedItems.length > 0 ? (
                displayedItems.map((item, index) => (
                  <AccordionItem key={index} item={item} searchQuery={searchQuery} activeTab={activeTab} isTopLevel={item.children.length === 0} />
                ))
              ) : (
                searchQuery.length >= 3 && <div>No matches found</div>
              )}
            </>
          )}

        </div>

        {/* <div className="staricon">
            <img src={starsIcon} alt="Star Icon" />
        </div> */}
      </div>
    </div>
  );
});

const getItemCodes = (item, activeTab) => {
  const codeString = getItemCode(item, activeTab); // Get the combined code string
  if (!codeString) return []; // Handle cases where codeString is empty or null
  if (activeTab === "CPT Tabular" || activeTab === "CPT Index") {
    // ACHI: Return the entire string as one code, regardless of brackets.
    return [codeString];
  } else if (activeTab === "PCS Tabular" || activeTab === "PCS Index") {
    return codeString.length === 7 ? [codeString] : [];
  } else {
    // ICD: Split by common delimiters, but ONLY if they are OUTSIDE brackets.
    const delimiter = /[†* ,]+(?![^[]*\])/; // Split outside of brackets
    const codes = codeString.split(delimiter).filter(code => code.trim() !== "");
    return codes;
  }
};

const getItemCode = (item, activeTab) => {
  switch (activeTab) {
    case "ICD 10 CM Index":
    case "CPT Index":
    case "PCS Index":
      return item.description;
    case "ICD 10 CM Tabular":
    case "CPT Tabular":
    case "PCS Tabular":
    case "American Coding Standard":

      return item.name;
    default:
      return item.name;
  }

};
const highlightText = (text, query) => {
  if (!query || query.length < 3 || !text) {
    return text; // Return original text if query is empty or too short
  }

  const lowerCaseText = text.toLowerCase();
  const lowerCaseQuery = query.toLowerCase();

  const parts = [];
  let lastIndex = 0;

  while (true) {
    const index = lowerCaseText.indexOf(lowerCaseQuery, lastIndex);
    if (index === -1) {
      parts.push(text.substring(lastIndex));
      break;
    }

    parts.push(text.substring(lastIndex, index));
    parts.push(<span className="highlighted">{text.substring(index, index + query.length)}</span>);
    lastIndex = index + query.length;
  }

  return parts;
};
const handleDragStartLogic = (e, draggableCodes, activeTab) => {
  if (draggableCodes.length > 0) {
    const dragData = {
      codes: draggableCodes,
      tab: activeTab,
    };
    e.dataTransfer.setData("application/json", JSON.stringify(dragData));
    e.dataTransfer.setData("text/plain", JSON.stringify(draggableCodes));
    e.dataTransfer.setData("text/uri-list", `data:text/plain;charset=utf-8,${encodeURIComponent(JSON.stringify(draggableCodes))}`);
    // console.log("Dragging medical codes:", dragData.codes, "from tab:", dragData.tab);
  } else {
    e.preventDefault();
  }
};


const AccordionItem = ({ item, activeTab, searchQuery, isTopLevel }) => {
  const { copiedCodes, setCopiedCodes } = useContext(CodeContext);
  const [isCopied, setIsCopied] = useState(false);
  const [localIsOpen, setLocalIsOpen] = useState(false);

  useEffect(() => {
    if (searchQuery.length > 2 && item.children?.some(child => child.matches)) {
      setLocalIsOpen(true); // Auto-open only if a child matches
    } else if (searchQuery.length < 3) {
      setLocalIsOpen(false); // Close if no search or short query
    }
  }, [searchQuery, item.children]);
  // useEffect(() => {
  //   if (searchQuery.length > 2) {
  //     // Check if the item or any of its descendants have matches
  //     const hasMatches = item.matches || (item.children?.some(child => child.matches || child.children?.some(c => c.matches)));
  //     setLocalIsOpen(hasMatches);
  //   } else {
  //     setLocalIsOpen(false);
  //   }
  // }, [searchQuery, item]);
  const toggleOpen = () => {
    setLocalIsOpen(!localIsOpen);
  };


  const codes = getItemCodes(item, activeTab);
  const draggableCodes = codes.filter(code => {
    if (activeTab === "CPT Tabular" || activeTab === "CPT Index") {
      // return true;
      return !code.includes('-');
    } else if (activeTab === "PCS Tabular" || activeTab === "PCS Index") {
      return code.length === 7 && !code.includes('-'); // PCS: must be 7 characters and no hyphen
    }
    else {
      return !code.includes('-');
    }
  });


  const handleDragStart = useCallback((e, draggableCodes) => {
    // console.log('Drag started with jyoti:', { draggableCodes, activeTab });
    handleDragStartLogic(e, draggableCodes, activeTab);
  }, [activeTab]);

  const handleCopyCode = (e) => {
    if (
      (activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular" || activeTab === "PCS Tabular") &&
      (!item.children || item.children.length === 0)
    ) {
      // Tabular view logic
      if (draggableCodes.length > 0) {
        const codesString = draggableCodes.join(",");
        // console.log(codesString, "copy code========");
        navigator.clipboard.writeText(codesString)
          .then(() => {
            setIsCopied(true);
            setCopiedCodes(codesString.split(","));
            setTimeout(() => setIsCopied(false), 3000);
          })
          .catch((err) => {
            console.error("Clipboard copy error:", err); // Log the error for debugging
            if (err instanceof Error) {
              toast.error("Failed to copy: " + err.message);
            } else {
              toast.error("Failed to copy: An unknown error occurred.");
            }
          });
      }
    } else if (
      (activeTab === "ICD 10 CM Index" || activeTab === "CPT  Index" || activeTab === "PCS Index") &&
      draggableCodes.length > 0
    ) {
      // Index view logic
      const codesString = draggableCodes.join(",");
      // console.log(codesString, "copy code========");
      navigator.clipboard.writeText(codesString)
        .then(() => {
          setIsCopied(true);
          setCopiedCodes(codesString.split(","));
          setTimeout(() => setIsCopied(false), 3000);
        })
        .catch((err) => {
          // console.error("Clipboard copy error:", err); // Log the error for debugging
          if (err instanceof Error) {
            toast.error("Failed to copy: " + err.message);
          } else {
            toast.error("Failed to copy: An unknown error occurred.");
          }
        });
    }
  };
  // console.log(activeTab, 'activeTab');

  return (
    <div className="codebook-wrapper accordion-item" key={"shbfsh"} >
      {isCopied && ( // Conditionally render the button
        <button className="code-copied-button">Code Copied    <img src={Bookopen} alt="plus" /></button>
      )}
      <div className="accordion-header" onClick={toggleOpen} >
        <div className="header-content ">
          {item.children?.length > 0 && (
            <span className="accordion-icon">{localIsOpen ? "▼" : "▶"}</span>
          )}
          {/* <span
            onClick={handleCopyCode}
            draggable={activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular" && (!item.children || item.children.length === 0)}
            onDragStart={(activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular") && (!item.children || item.children.length === 0) ? (e) => handleDragStart(e, draggableCodes) : null}
            style={{
              color: (draggableCodes.length > 0 && (activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular") && (!item.children || item.children.length === 0)) ? 'blue' : 'inherit',
              textDecoration: (draggableCodes.length > 0 && (activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular") && (!item.children || item.children.length === 0)) ? 'underline' : 'none',
              fontWeight: isTopLevel || item.children?.length > 0 ? "bold" : "normal",

            }}
          >
            {highlightText(item.name, searchQuery)}

          </span> */}
          <span
            onClick={handleCopyCode}
            draggable={
              (activeTab === "ICD 10 CM Tabular" ||
                activeTab === "CPT Tabular" ||
                activeTab === "PCS Tabular") &&
              (!item.children || item.children.length === 0)
            }
            onDragStart={
              (activeTab === "ICD 10 CM Tabular" ||
                activeTab === "CPT Tabular" ||
                activeTab === "PCS Tabular") &&
                (!item.children || item.children.length === 0)
                ? (e) => handleDragStart(e, draggableCodes)
                : null
            }
            style={{
              color:
                draggableCodes.length > 0 &&
                  (activeTab === "ICD 10 CM Tabular" ||
                    activeTab === "CPT Tabular" ||
                    activeTab === "PCS Tabular") &&
                  (!item.children || item.children.length === 0)
                  ? "blue"
                  : "inherit",
              textDecoration:
                draggableCodes.length > 0 &&
                  (activeTab === "ICD 10 CM Tabular" ||
                    activeTab === "CPT Tabular" ||
                    activeTab === "PCS Tabular") &&
                  (!item.children || item.children.length === 0)
                  ? "underline"
                  : "none",
              fontWeight: isTopLevel || item.children?.length > 0 ? "bold" : "normal",
            }}
          >
            {highlightText(item.name, searchQuery)}
          </span>

          {/* <span

            className="item-description"
            onClick={handleCopyCode}
            draggable={
              (activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular")
                ? false
                : draggableCodes.length > 0
            }
            onDragStart={
              (activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular")
                ? null
                : draggableCodes.length > 0
                  ? (e) => handleDragStart(e, draggableCodes)
                  : null
            }
            style={{
              color: draggableCodes.length > 0 && (activeTab === "ICD 10 CM Index" || activeTab === "CPT Index") ? 'blue' : 'inherit',
              textDecoration: draggableCodes.length > 0 && (activeTab === "ICD 10 CM Index" || activeTab === "CPT Index") ? 'underline' : 'none',
            }}
          >
            <span className="item-descrpition-value">{highlightText(item.description, searchQuery)}</span>

          </span> */}
          <span
            className="item-description"
            onClick={handleCopyCode}
            draggable={
              (activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular" || activeTab === "PCS Tabular")
                ? false
                : draggableCodes.length > 0
            }
            onDragStart={
              (activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular" || activeTab === "PCS Tabular")
                ? null
                : draggableCodes.length > 0
                  ? (e) => handleDragStart(e, draggableCodes)
                  : null
            }
            style={{
              color:
                draggableCodes.length > 0 &&
                  (activeTab === "ICD 10 CM Index" || activeTab === "CPT Index" || activeTab === "PCS Index")
                  ? 'blue'
                  : 'inherit',
              textDecoration:
                draggableCodes.length > 0 &&
                  (activeTab === "ICD 10 CM Index" || activeTab === "CPT Index" || activeTab === "PCS Index")
                  ? 'underline'
                  : 'none',
            }}
          >
            <span className="item-descrpition-value">
              {highlightText(item.description, searchQuery)}
            </span>
          </span>

          {(item.inclusion && localIsOpen) && <div className="font_green">
            <b>Includes</b> : {highlightText(item.inclusion, searchQuery)}
          </div>}
          {(item.useAdditional && localIsOpen) && <div className="font_blud">
            <b>useAdditional</b> : {highlightText(item.useAdditional, searchQuery)}
          </div>}
          {(item.exclusion && localIsOpen) && <div className="font_red">
            <b>Excludes</b> : {highlightText(item.exclusion, searchQuery)}
          </div>}


        </div>

      </div>
      {localIsOpen && item.children?.length > 0 && (
        <div className="accordion-children">
          {item.children.map((child) => (
            <AccordionItem key={child.id} item={child} activeTab={activeTab} searchQuery={searchQuery} />
          ))}
        </div>
      )}
    </div>
  );
};

export default React.memo(CodeBookUsa);